import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';
import { OrderDetailAttributes } from '@albatrosdeveloper/ave-models-package';
import { getCode } from 'app/utils/method';

/**
 * Material Cell Renderer
 *
 * Renders material code (bold) and material name on separate lines
 *
 * @example
 * ```typescript
 * {
 *   field: 'materialName',
 *   headerName: 'Material',
 *   cellRenderer: MaterialCellRendererComponent,
 *   minWidth: 200
 * }
 * ```
 */
@Component({
  selector: 'app-material-cell-renderer',
  standalone: true,
  imports: [CommonModule],
  template: `
    <b class="f-10" *ngIf="materialCode">
      {{ materialCode }} <br>
    </b>
    <span class="font-descrip">{{ params.data?.materialName?.name }}</span>
  `,
})
export class MaterialCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  get materialCode(): string | null {
    return getCode(this.params.data?.materialName);
  }
}
